import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { USER } from '../../data/reducer';

import NotificationSuccess from './components/userInfoRequestsNotificationSuccess';
import NotificationFailed from './components/userInfoRequestsNotificationFailed';

import { postUserInfoRequestStatus } from '../../data/user/userInfoRequests/actions';

const UserInfoRequestsNotification = ({
  userInfoRequests,
  officialServicesState,
}) => {
  const { isInboxActive, fetching } = officialServicesState;
  const [visibility, setVisibility] = useState(false);

  useEffect(() => {
    setVisibility(
      !userInfoRequests.dissmissed &&
        (userInfoRequests.lastSaveStatus ===
          postUserInfoRequestStatus.SUCCESS ||
          userInfoRequests.lastSaveStatus === postUserInfoRequestStatus.FAILED)
    );
  }, [userInfoRequests.dissmissed, userInfoRequests.lastSaveStatus]);

  // Hide notification if not sent or is dismissed
  if (!visibility) {
    return null;
  }

  // Show sent info request notification
  return userInfoRequests.lastSaveStatus ===
    postUserInfoRequestStatus.FAILED ? (
    <NotificationFailed setVisibility={setVisibility} />
  ) : (
    <NotificationSuccess
      setVisibility={setVisibility}
      isInboxActive={isInboxActive}
      fetching={fetching}
    />
  );
};

const mapStateToProps = (state) => {
  return {
    officialServicesState: state[USER].officialServices,
    userInfoRequests: state[USER].userInfoRequests,
  };
};

export default connect(mapStateToProps)(UserInfoRequestsNotification);
